// ========================================
// API CONFIGURATION
// ========================================
// Centralized API URL configuration for all form submissions

// Check if we're in production
const isProduction = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    return hostname !== 'localhost' && hostname !== '127.0.0.1';
  }
  return false;
};

// Determine API URL based on environment
const getApiUrl = () => {
  // First check for environment variable (set during build)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Fallback based on current hostname
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    // Local development
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:5000';
    }

    // Production - Base URL only (components add /api/endpoint)
    return 'https://api.time2find.com';
  }

  // Default fallback
  return 'http://localhost:5000';
};

export const API_URL = getApiUrl();

// API endpoints
export const API_ENDPOINTS = {
  // If env var is a full URL, use it. Otherwise, assume it's a Formspree ID.
  contact: process.env.REACT_APP_FORMSPREE_CONTACT_ID
    ? (process.env.REACT_APP_FORMSPREE_CONTACT_ID.startsWith('http')
      ? process.env.REACT_APP_FORMSPREE_CONTACT_ID
      : `https://formspree.io/f/${process.env.REACT_APP_FORMSPREE_CONTACT_ID}`)
    : '/api/contact',

  booking: process.env.REACT_APP_FORMSPREE_BOOKING_ID
    ? (process.env.REACT_APP_FORMSPREE_BOOKING_ID.startsWith('http')
      ? process.env.REACT_APP_FORMSPREE_BOOKING_ID
      : `https://formspree.io/f/${process.env.REACT_APP_FORMSPREE_BOOKING_ID}`)
    : '/api/booking',

  health: '/api/health',
};

export default API_URL;
